import styled from "styled-components";

export const CtaButton = styled.button`
  display: inline-block;
  margin: 0 1em;
  background: transparent;
  font: inherit;
  border: 0;
  outline: 0;
  padding: 0;
  transition: all 100ms ease-in;
  cursor: pointer;
  background: #28b81e;
  text-transform: uppercase;
  font-weight: 700;
  color: #fff;
  box-shadow: 0 0 10px 2px rgb(0 0 0 / 10%);
  border-radius: 2px;
  padding: 12px 36px;
  margin-bottom: 1.5em;

  &:hover {
    background: #00b00e;
  }

  &:active {
    background: #00b00e;
  }

  &:disabled {
    background: #dddddd;
    cursor: initial;
  }
`;
